import React from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Layout, Row, Typography,
} from 'antd';
import './Panels.css';

const { Title } = Typography;

/**
 * Bynx Panel - Layout (a panel with a title and padding around the contents)
 * @param titleId     translation ID for heading text
 * @param titleLevel  heading title level (1-4)
 * @param children    contents of the panel
 * @returns {*}
 * @constructor
 */
function PanelLayout({ titleId, titleLevel, children }) {
  return (
    <Layout className="via-panel-layout">
      <Row align="middle" justify="start" type="flex">
        <Title level={titleLevel}><FormattedMessage id={titleId} /></Title>
      </Row>
      <Row>
        {children}
      </Row>
    </Layout>
  );
}

// Validate the prop type parameters.
PanelLayout.propTypes = {
  titleId: PropTypes.string.isRequired,
  titleLevel: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

export default PanelLayout;
